import { useEffect } from 'react';

import { useScroll } from '@hooks/hooks';

const StickyElement = ({
  onStickyStateChange,
  max,
}: {
  onStickyStateChange: (value: boolean) => void;
  max: number;
}) => {
  const scroll = useScroll();
  useEffect(() => {
    if (scroll.y && scroll.y > max) {
      onStickyStateChange(true);
    } else {
      onStickyStateChange(false);
    }
  }, [scroll.y, onStickyStateChange, max]);
  return null;
};

export default StickyElement;
